import { Providers } from '@/app/providers'
import { AppRouter } from '@/app/router'

/**
 * Entry-point glue: composes app providers and router.
 * Product wiring lives in app/ (providers, router, queryClient).
 */
function App() {
  return (
    <Providers>
      <AppRouter />
    </Providers>
  )
}

export default App
